import { useQuery } from '@tanstack/react-query';
import axios from '../../../services/axiosInstance'; 
import { GBP } from '../types/Listing';

export interface MediaItem {
  name?: string;
  mediaFormat?: 'PHOTO' | 'VIDEO';
  googleUrl?: string;
  thumbnailUrl?: string;
  createTime?: string;
  description?: string;
}

function parseLocationParts(gbp: GBP | null): { accountId: string; locationId: string } | null {
  if (!gbp) return null;

  const fullName = gbp.locationId ?? '';

  const fullMatch = fullName.match(/^accounts\/([^/]+)\/locations\/([^/]+)$/);
  if (fullMatch) {
    return {
      accountId: fullMatch[1],
      locationId: fullMatch[2],
    };
  }

  const shortMatch = fullName.match(/^locations\/([^/]+)$/);
  if (shortMatch && gbp.accountName) {
    return {
      accountId: gbp.accountName.replace(/^accounts\//, ''),
      locationId: shortMatch[1],
    };
  }

  return null;
}

export const useLocationMedia = (
  gbp: GBP | null,
  enabled: boolean,
  subjectEmail?: string // ✅ ajouté
) => {
  const parts = parseLocationParts(gbp);

  return useQuery<MediaItem[]>({
    queryKey: [
      'gbp',
      'media',
      parts?.accountId,
      parts?.locationId,
      subjectEmail // ✅ important pour cache
    ],

    queryFn: async () => {
      if (!parts) return [];

      const params = new URLSearchParams();
      if (subjectEmail) {
        params.append("subjectEmail", subjectEmail);
      }

      const res = await axios.get(
        `/api/gbp/accounts/${parts.accountId}/locations/${parts.locationId}/media?${params.toString()}`
      );

      return (res.data?.media ?? []) as MediaItem[];
    },

    enabled: enabled && !!parts,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};